// Version traduite complète de AboutPage.jsx
// À remplacer dans AboutPage.jsx

import styles from './AboutPage.module.css';
import { useTranslation } from '../hooks/useTranslation';

function AboutPage() {
  const { t } = useTranslation();
  
  return (
    <div className={styles.page}>
      <h1>{t('about.title')}</h1>
      <p className={styles.lastUpdate}>{t('about.lastUpdate')}</p>

      <div className={styles.section}>
        <h2>{t('about.mission.title')}</h2>
        <p dangerouslySetInnerHTML={{ __html: t('about.mission.text1') }} />
        <p>{t('about.mission.text2')}</p>
      </div>

      <div className={styles.section}>
        <h2>{t('about.why.title')}</h2>
        <p>{t('about.why.text1')}</p>
        <p dangerouslySetInnerHTML={{ __html: t('about.why.text2') }} />
        <p>{t('about.why.text3')}</p>
      </div>

      <div className={styles.section}>
        <h2>{t('about.profiles.title')}</h2>
        <p dangerouslySetInnerHTML={{ __html: t('about.profiles.text1') }} />

        <p dangerouslySetInnerHTML={{ __html: t('about.profiles.text2') }} />
        <ul>
          {t('about.profiles.items').map((item, index) => (
            <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
          ))}
        </ul>

        <p>{t('about.profiles.text3')}</p>
      </div>

      <div className={styles.section}>
        <h2>{t('about.name.title')}</h2>
        <p>{t('about.name.text1')}</p>
        <p>
          <em>{t('about.name.quote')}</em>, {t('about.name.text2')}
        </p>
        <p>{t('about.name.text3')}</p>
      </div>

      <div className={styles.section}>
        <h2>{t('about.values.title')}</h2>
        <ul>
          {t('about.values.items').map((item, index) => (
            <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
          ))}
        </ul>
      </div>

      <div className={styles.section}>
        <h2>{t('about.contact.title')}</h2>
        <p>
          {t('about.contact.text')}{' '}
          <a href="mailto:cheriecoiffer@gmail.com">cheriecoiffer@gmail.com</a>
        </p>
      </div>
    </div>
  );
}

export default AboutPage;
